import type { FC } from 'react';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

interface Props {
  readonly?: boolean;
}

export const DriveEmpty: FC<Props> = (props) => {
  const { t } = useAppTranslation();
  const { readonly } = props;

  return (
    <div className="cursor-default login-wrapper">
      <div className="text-[70px] leading-[80px]">☕️</div>
      <div className="text-grey4 text-t1">{t('components.empty.drive_empty.folder_empty')}</div>
      {!readonly && (
        <div className="flex items-center justify-center h-10">
          <span className="text-grey3 text-t2">
            {t('components.empty.drive_empty.drag_or_upload')}
          </span>
        </div>
      )}
    </div>
  );
};
